const apiBase: string = '/api';
const commonBase: string = '/common';
const flashmeetingBase: string = '/fm';

export const API = {
  SIGN_IN: apiBase + commonBase + '/auth/sign-in',
  CLIENT: apiBase + commonBase + '/clients/',
  SITES: apiBase + commonBase + '/sites/by_clients/',
  USERS: apiBase + commonBase + '/users/',
  SECTORBYSITE: apiBase + commonBase + '/sectors/by_sites/',
  EVENTMANAGERS: apiBase + flashmeetingBase + '/event-managers',
  EVENT_MANAGERS_BY_SITE: apiBase + flashmeetingBase + '/event-managers/site/bySiteIDs',
  CLOSED_DAYS: apiBase + flashmeetingBase + '/closed-days',
  HOLIDAY_LOCTION: apiBase + flashmeetingBase + '/holiday-location',
  TABLEPARTICIPANT: '/participants',
  VISUALISATION: apiBase + flashmeetingBase + '/visualisation',
  KPI: apiBase + flashmeetingBase + '/kpi',
  ENGAGEMENTS: apiBase + flashmeetingBase + '/engagements',
  THEMES: apiBase + flashmeetingBase + '/themes',
  THEMES_BY_SITES: apiBase + flashmeetingBase + '/themes/by-sites/get',
  THEMES_BY_EVENT_MANAGER: apiBase + flashmeetingBase + '/themes/event-managers/byId',
  COMMON_THEMES_BY_EVENT_MANAGER: apiBase + flashmeetingBase + '/themes/common-themes/by-event-managers',
  THEMES_EXTRACTION_BY_FILTERS: apiBase + flashmeetingBase + '/themes/extraction/by-filters',
  EVENTS: apiBase + flashmeetingBase + '/events',
  DATAEXPORT: apiBase + flashmeetingBase + '/data-export/',
  GLOBAL_SETTINGS: apiBase + flashmeetingBase + '/global_settings',
  SECTOR_SETTINGS: apiBase + flashmeetingBase + '/sector_settings',
  DIARY_NOTE: apiBase + flashmeetingBase + '/diary-note',
  SETTINGS: apiBase + flashmeetingBase + '/global_settings',
  NOTES: apiBase + flashmeetingBase + '/notes',
  FIELD_SETTINGS: apiBase + flashmeetingBase + '/field-settings',
  RESOLUTION_PLAN: '/api/rp' + flashmeetingBase,
  EXTRACTION_SAVED_VIEWS: apiBase + flashmeetingBase + '/extraction/saved-views',
  CHART_SECTION: apiBase + flashmeetingBase + '/chart_section',
  CHART_UNITE: apiBase + flashmeetingBase + '/chart_unit',
  CHART_OF_SECTION: apiBase + flashmeetingBase + '/chart_info',
  CHART_VALUE: apiBase + flashmeetingBase + '/chart_value',
};
